export default "__VITE_ASSET__PavOJady9TG7Z1KlGPtWqA__"